<template>
	<div id="steam-app">
		<div class="center-align">
			<h3>Steam-Library - <u>Text-Only</u></h3>
			<p class="text-small-no-margin">
				Display and search through large Steam-Libraries that take ages to load
				in the official client.
				<br />
				Press enter to confirm input fields.
			</p>
			<br />
			<input
				class="inputField form-control text-center"
				v-model="inputId"
				v-on:keyup.enter="redirect_urlParam"
				placeholder="profile-link / vanity-url / steamID"
			/>
		</div>

		<hr />

		<div v-if="showTable">
			<table class="table-padded col-8 offset-2">
				<tr>
					<th>Total games:</th>
					<td>{{ gameCount }}</td>
				</tr>
				<tr>
					<th>Total playtime:</th>
					<td>{{ formatTime(playtimeTotal) }}</td>
				</tr>
				<tr>
					<th>Profile:</th>
					<td>
						<a
							v-bind:href="'http://steamcommunity.com/profiles/' + steamId"
							target="_blank"
							><i>[{{ steamId }}]</i></a
						>
					</td>
				</tr>
			</table>

			<hr />

			<div class="center-align">
				<!--
				<textarea class="inputField" v-model="inputSearchIG" rows="8" v-on:keyup.enter="filterIG" placeholder="Multi-Search&#10;Paste newline separated names here!&#10;&#10;(In case of Indiegala Gift Page: content from first games name to last games name)"></textarea>
				<br/>
				-->
				<input
					class="inputField form-control text-center"
					v-model="inputSearchSingle"
					v-on:keyup.enter="filterSingle"
					placeholder="Search"
				/>
				<br />
				<table class="table-padded">
					<thead>
						<tr>
							<th>AppID</th>
							<th>Playtime</th>
							<th>Name</th>
						</tr>
					</thead>
					<tr v-for="game in filteredGames" :key="game.appid">
						<td class="center-align nowrap">
							<a
								v-bind:href="'http://store.steampowered.com/app/' + game.appid"
								target="_blank"
								><i>[{{ game.appid }}]</i></a
							>
						</td>
						<td class="center-align nowrap">
							{{ formatTime(game.playtime_forever) }}
						</td>
						<td>{{ game.name }}</td>
					</tr>
				</table>
			</div>

			<hr />

			<address class="center-align" style="margin-top:32px">
				Contact:<br />
				<a href="mailto:mail@zipixx.com">mail@zipixx.com</a><br />
				<a href="https://steamcommunity.com/id/zipixx" target="_blank"
					>https://steamcommunity.com/id/zipixx</a
				><br />
				:)
			</address>
		</div>
	</div>
</template>

<script>
import * as steam_api from '@/api/steam';

export default {
	name: 'Steam.vue',
	data: function() {
		return {
			inputId: '',
			steamId: '',
			gameCount: '0',
			playtimeTotal: '0',
			games: [],
			filteredGames: [],
			inputSearchSingle: '',
			inputSearchIG: '',

			showTable: false
		};
	},
	methods: {
		redirect_urlParam: function() {
			window.location.href = window.location.pathname + '?id=' + this.inputId;
		},
		search: function() {
			this.showTable = false;

			this.inputId = this.inputId.replace('https://steamcommunity.com/id/', '');
			this.inputId = this.inputId.replace(
				'https://steamcommunity.com/profiles/',
				''
			);
			this.inputId = this.inputId.replace('/', '');
			/*
			translate vanityurl, load games and show full table
			*/
			if (isNaN(this.inputId)) {
				steam_api.get_id(this.inputId).then(result => {
					this.steamId = result;
					this.create_library_table();
				});
			} else {
				this.steamId = this.inputId;
				this.create_library_table();
			}
		},
		create_library_table: function() {
			steam_api.get_library(this.steamId).then(library => {
				this.gameCount = library['game_count'];
				this.games = library['games'];

				var total = 0;
				for (var i = 0; i < this.games.length; i++) {
					total += this.games[i]['playtime_forever'];
				}
				this.playtimeTotal = total;

				function compareTime(a, b) {
					if (a.playtime_forever < b.playtime_forever) return 1;
					if (a.playtime_forever > b.playtime_forever) return -1;
					return 0;
				}

				this.games.sort(compareTime);

				//show full table or if search param set, filtered result
				this.filterSingle();

				this.showTable = true;
			});
		},
		filterSingle: function() {
			if (this.inputSearchSingle === '') {
				this.filteredGames = this.games;
				return;
			}

			var result = [];
			for (var i = 0; i < this.games.length; i++) {
				if (
					this.games[i].name
						.toUpperCase()
						.indexOf(this.inputSearchSingle.toUpperCase()) > -1
				) {
					result.push(this.games[i]);
				}
			}
			this.filteredGames = result;
		},
		/*
		filterIG: function() {
			if (this.inputSearchIG === '') {
				this.filteredGames = this.games;
				return;
			}

			var txt = this.inputSearchIG;
			//console.log("txt: " + txt);
			this.inputSearchIG = this.inputSearchIG.replace(
				/GIFT THIS GAME TO A FRIEND/g,
				''
			);
			this.inputSearchIG = this.inputSearchIG.replace(
				/Click the Steam button to redeem your key/g,
				''
			);
			this.inputSearchIG = this.inputSearchIG.replace(/\n\s*\n/g, '\n');
			this.inputSearchIG = this.inputSearchIG.slice(0, -1);
			//console.log(txt);
			var gamesIG = this.inputSearchIG.split('\n');
			console.log(gamesIG);

			var result = [];
			for (gameIGindex in gamesIG) {
				if (gamesIG[gameIGindex] === undefined) continue;
				console.log('CHECK: ' + gamesIG[gameIGindex].toUpperCase());
				for (var i = 0; i < this.games.length; i++) {
					if (
						this.games[i].name
							.toUpperCase()
							.indexOf(gamesIG[gameIGindex].toUpperCase()) > -1
					) {
						result.push(this.games[i]);
					}
				}
			}
			this.filteredGames = result;
		},*/

		formatTime: function(time) {
			return Math.trunc(time / 60) + 'h ' + (time % 60) + 'm';
		},
		getURLParameter: function(name) {
			return (
				decodeURIComponent(
					(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
						location.search
					) || [null, ''])[1].replace(/\+/g, '%20')
				) || null
			);
		}
	},
	mounted: function() {
		var params = {};
		params['id'] = this.getURLParameter('id');

		if (params.id != null) {
			params['search'] = this.getURLParameter('search');
			this.inputSearchSingle = params.search != null ? params.search : '';

			this.inputId = params.id;
			this.search();
		}
	}
};
</script>

<style scoped>
#steam-app {
	max-width: 600px;
	margin: 0 auto;
	margin-top: 20px;
	font-family: sans-serif;
}
.center-align {
	text-align: center;
}
.center-align-margin-inside > * {
	margin: 0 auto;
}
.nowrap {
	white-space: nowrap;
}
hr {
	height: 1px;
	border: 0;
	background-color: #ddd;
}
a {
	color: inherit;
	text-decoration: none;
}
.inputField {
	background-color: #333;
	color: #ddd;
	border: 1px solid #555;
	padding: 5px;
}
.table-padded {
	padding: 5px 20px 5px 0px;
}
.table-padded th,
.table-padded td {
	padding-left: 20px;
}
.text-small-no-margin {
	font-size: 13px;
	margin: 0px;
}
</style>
